module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-002sp-022.85f920d2.jpg";